// extracted by mini-css-extract-plugin
export var featuresList = "features-module--featuresList--1CbBq";